import { render, staticRenderFns } from "./AddRuleset.vue?vue&type=template&id=1b84616e&scoped=true&"
import script from "./AddRuleset.vue?vue&type=script&lang=js&"
export * from "./AddRuleset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b84616e",
  null
  
)

export default component.exports